import { createAsyncAction } from "typesafe-actions";

import { SavedSetting, SettingSectionView, SettingsRequestError, SettingUpdate } from "../interfaces";
import { SettingsActionTypes } from "./constants";

export const fetchSettings = createAsyncAction(
  SettingsActionTypes.FETCH_SETTINGS,
  SettingsActionTypes.FETCH_SETTINGS_SUCCESS,
  SettingsActionTypes.FETCH_SETTINGS_FAILURE,
)<undefined, SettingSectionView[], SettingsRequestError>();

/** Success carries every key the save just wrote, not just a message -- the reducer uses
 * `savedSettings` to update `sections` in place, which is what makes a just-saved key read as clean
 * again (SettingsSection compares the draft against `sections`, never against a frozen snapshot). */
export interface SaveSettingsSuccess {
  message: string;
  savedSettings: SavedSetting[];
}

export const saveSettings = createAsyncAction(
  SettingsActionTypes.SAVE_SETTINGS,
  SettingsActionTypes.SAVE_SETTINGS_SUCCESS,
  SettingsActionTypes.SAVE_SETTINGS_FAILURE,
)<SettingUpdate[], SaveSettingsSuccess, SettingsRequestError>();
